import { PropsWithChildren } from 'react';
import { observer } from 'mobx-react';
import cls from 'classnames';

import styles from './TreeItemContainer.module.css';

export interface TreeItemContainerProps {
  isSelected: boolean;
  className?: string;
}

function TreeItemContainer(props: PropsWithChildren<TreeItemContainerProps>) {
  const { isSelected, className, children } = props;

  return <div className={cls(styles.treeItemContainer, { [styles.selected]: isSelected }, className)}>{children}</div>;
}

export default observer(TreeItemContainer);
